import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";

const EmployeeDetailSettlement = () => {
    return (
        <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
                <Col sm={6}>
                    <NFTextInput title={"Tin"} fieldName={"tin"} />
                </Col>
                <Col sm={6}>
                    <NFLookupInput
                        title={"Gender"}
                        fieldName={"gender"} items={[]}                        // items={Gender}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        title={"Created Date"}
                        fieldName={"createdDate"}
                    />
                </Col>
                <Col sm={6}>
                    <NFDateInput
                        fieldName={"dateOfBirth"}
                        title={"Date of Birth"}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default EmployeeDetailSettlement;
